import {
  CustomContentItemParams,
  CustomContentItemEntity,
} from "@shared/services/event_tracking/entities/custom_content/custom_content_item_entity";

export class CustomContentRecipeSectionEntity extends CustomContentItemEntity {
  constructor(params: CustomContentItemParams) {
    super(params);
    this.type = "custom_content_recipe_section";
    this.entity_version = 2;
  }
}
